import leadSourceFields from './lead-sources';

export default {
    customFields: [
        {resource: 'subscriptions', path: 'customFields'},
        {resource: 'customers', path: 'customer/customFields'},
    ],
    fields: [
        {field: 'id', isDefault: true},
        {field: 'status', isDefault: true},
        {field: 'customerId', isDefault: true},
        {field: 'websiteId', isDefault: true},
        {field: 'planId', isDefault: true},
        {field: 'initialInvoiceId', isDefault: true},
        {field: 'billingContactId', isDefault: true},
        {field: 'deliveryContactId', isDefault: true},
        {field: 'autopay', isDefault: true},
        {field: 'quantity', isDefault: true},
        {field: 'currency', isDefault: false},
        {field: 'createdTime', isDefault: true},
        {field: 'updatedTime', isDefault: true},
        {field: 'startTime', isDefault: true},
        {field: 'endTime', isDefault: true},
        {field: 'renewalTime', isDefault: true},
        {field: 'canceledTime', isDefault: true},
        {field: 'canceledBy', isDefault: false},
        {field: 'cancelCategory', isDefault: false},
        {field: 'activationTime', isDefault: true},
        {field: 'cancelSource', isDefault: false},
        {field: 'rebillNumber', isDefault: false},
        {field: 'inTrial', isDefault: false},
        {field: 'billingAddress/firstName', isDefault: false},
        {field: 'billingAddress/lastName', isDefault: false},
        {field: 'billingAddress/address', isDefault: false},
        {field: 'billingAddress/address2', isDefault: false},
        {field: 'billingAddress/organization', isDefault: false},
        {field: 'billingAddress/city', isDefault: false},
        {field: 'billingAddress/region', isDefault: false},
        {field: 'billingAddress/country', isDefault: false},
        {field: 'billingAddress/postalCode', isDefault: false},
        {field: 'billingAddress/email', isDefault: false},
        {field: 'billingAddress/phoneNumber', isDefault: false},
        {field: 'deliveryAddress/firstName', isDefault: false},
        {field: 'deliveryAddress/lastName', isDefault: false},
        {field: 'deliveryAddress/address', isDefault: false},
        {field: 'deliveryAddress/address2', isDefault: false},
        {field: 'deliveryAddress/organization', isDefault: false},
        {field: 'deliveryAddress/city', isDefault: false},
        {field: 'deliveryAddress/region', isDefault: false},
        {field: 'deliveryAddress/country', isDefault: false},
        {field: 'deliveryAddress/postalCode', isDefault: false},
        {field: 'deliveryAddress/email', isDefault: false},
        {field: 'deliveryAddress/phoneNumber', isDefault: false},
        {field: 'riskMetadata/ipAddress', isDefault: false},
        {field: 'riskMetadata/isVpn', isDefault: false},
        {field: 'riskMetadata/isProxy', isDefault: false},
        {field: 'riskMetadata/isTor', isDefault: false},
        {field: 'riskMetadata/isHosting', isDefault: false},
        {field: 'riskMetadata/isp', isDefault: false},
        {field: 'riskMetadata/vpnServiceName', isDefault: false},
        {field: 'riskMetadata/score', isDefault: false},
        {field: 'riskMetadata/fingerprint', isDefault: false},
        {field: 'riskMetadata/country', isDefault: false},
        {field: 'riskMetadata/city', isDefault: false},
        {field: 'riskMetadata/latitude', isDefault: false},
        {field: 'riskMetadata/longitude', isDefault: false},
        {field: 'riskMetadata/accuracyRadius', isDefault: false},
        {field: 'riskMetadata/postalCode', isDefault: false},
        {field: 'riskMetadata/timeZone', isDefault: false},
        {field: 'riskMetadata/distance', isDefault: false},
    ].concat(leadSourceFields),
};
